/* eslint-disable no-sequences */
/* eslint-disable react/prop-types */
// React
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
// redux

// MUI
import { Paper, Typography, Link, RadioGroup, Radio, FormControl, FormControlLabel, Grid } from '@material-ui/core';
import ADGMPanelInputsGeneratorBody from 'aurora-components/ADGMPanelInputsGenerator/ADGMPanelInputsGeneratorBody';
// styles
import withStyles from '@material-ui/core/styles/withStyles';
import {
  ADGMItemDetails,
  ADGMSelect,
  ADGMImage,
  ADGMAlert,
  ADGMTextField,
  ADGMSelectMap,
  ADGMMap,
} from 'aurora-components';
import moment from 'moment';

import messages from 'aurora-translations';
import styles from './styles';
import { keyEmptyCheck, getDropdownLabelFromValue } from '../../utils/utils';
/** ****************
Props Documentation:
--------------------
entites : array of owners comes from current application (application.owners)
contractDetails: object of contract details comes from Reducer 
setContractDetails: function to set contract details comes from mortgage Action (modules/mortgage/actions.js)
isEditable: to show the radio buttons
***************** */

const AppoimentDetails = ({
  classes,
  isEditable,
  appoimentLocations,
  emrtsLookup,
  hanldeAppoinmentDetails,
  appointmentDetails,
  hanldeAppoinmentTime,
  appointmentWorkingHours,
  auditorFlow,
  title,
  intl,
}) => {
  const locale = localStorage.getItem('lang');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPin, setSelectedPin] = useState(null);
  const [selectOption, setSelectOption] = useState('');
  const [selectDetail, setSelectDetail] = useState(null);

  const getfixedDetail = useCallback(
    (value, data) => {
      hanldeAppoinmentTime(value);
      const detailObject = {
        ...data,
        workingHours: appointmentWorkingHours,
      };
      setSelectDetail(detailObject);
      return null;
    },
    [appointmentWorkingHours.length, appointmentDetails.length],
  );
  const handleSelect = (name, value) => {
    setSelectDetail(null);
    name === 'locationId' && getfixedDetail(value?.valueId, value?.data);
    const setArray = {
      type: selectOption,
      ...(name === 'locationId' ? { locationId: value?.valueId } : {}),
      ...(selectOption === 'DARI_AT_YOUR_PLACE'
        ? {
            dariAtYourPlaceDetails: {
              ...appointmentDetails?.dariAtYourPlaceDetails,
              ...(name === 'emirate' ? { municipalityId: value?.valueId } : {}),
              ...(name === 'selectedPin'
                ? {
                    latitude: value?.location?.lat,
                    locationName: value?.name,
                    longitude: value?.location?.lng,
                  }
                : {}),
            },
          }
        : {}),
    };
    hanldeAppoinmentDetails(setArray);
  };
  const onSubmitLocation = (name, location) => {
    setSelectedPin({ name, location });
    handleSelect('selectedPin', { name, location });
  };

  const handleChange = useCallback(
    key => {
      const setArrayoption = {
        type: key.target.value,
      };
      setSelectOption(key.target.value);
      hanldeAppoinmentDetails(setArrayoption);
      setSelectDetail(null);
    },
    [appointmentDetails.length],
  );
  const handleCloseModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  useEffect(() => {
    if (appointmentDetails) {
      setSelectOption(appointmentDetails?.type);
      const detailObject = {
        ...appointmentDetails,
      };
      setSelectDetail(detailObject);
      if (appointmentDetails?.type === 'DARI_AT_YOUR_PLACE') {
        const locationObject = {
          name: appointmentDetails?.dariAtYourPlaceDetails?.locationName,
          location: {
            lat: appointmentDetails?.dariAtYourPlaceDetails?.latitude,
            lng: appointmentDetails?.dariAtYourPlaceDetails?.longitude,
          },
        };
        setSelectedPin(locationObject);
      }
    }
  }, []);

  const getSelectOptions = useCallback(
    name => {
      if (name === 'choose_municipality') {
        return appoimentLocations
          .filter(val => val.entityType === 'MUNICIPALITY')
          .map(val => ({
            label: locale === 'ar' ? val?.locationNameAr || val?.locationNameEn : val?.locationNameEn,
            value: val?.id,
            valueId: val?.id,
            data: val,
          }));
      }
      if (name === 'dariOffice') {
        return appoimentLocations
          .filter(val => val.entityType === 'DARI_OFFICE')
          .map(val => ({
            label: locale === 'ar' ? val?.locationNameAr || val?.locationNameEn : val?.locationNameEn,
            value: val?.id,
            valueId: val?.id,
            data: val,
          }));
      }
      if (name === 'emirateLookup') {
        return emrtsLookup.map(val => ({
          label: locale === 'ar' ? val?.nameAr || val?.nameEn : val?.nameEn,
          value: val?.id,
          valueId: val?.id,
        }));
      }

      return null;
    },
    [appoimentLocations.length],
  );
  const SELLING_DETAILS_PANEL_FIELDS = useMemo(() => {
    return [
      {
        title: '',

        labels: [
          ...(appointmentDetails?.type === 'MUNICIPALITY_BRANCH' || appointmentDetails?.type === 'DARI_OFFICE'
            ? [
                {
                  label: keyEmptyCheck('Appointment_type'),
                  value: keyEmptyCheck(
                    appointmentDetails?.type === 'MUNICIPALITY_BRANCH' ? 'Municipality_branch' : 'dari_offices',
                  ),
                },
                {
                  label: keyEmptyCheck(appointmentDetails?.type === 'MUNICIPALITY_BRANCH' ? 'branch_name' : 'place'),
                  value:
                    appointmentDetails?.type === 'MUNICIPALITY_BRANCH'
                      ? getDropdownLabelFromValue(
                          getSelectOptions('choose_municipality'),
                          appointmentDetails?.locationId,
                        )
                      : locale === 'en'
                      ? appointmentDetails?.name
                      : appointmentDetails?.nameAr,
                },
                {
                  label: keyEmptyCheck('working_hours'),
                  value: appointmentDetails?.workingHours ?? appointmentWorkingHours,
                },
                {
                  label: keyEmptyCheck('contact_details'),
                  value: appointmentDetails?.mobile ?? '~',
                },
                {
                  label: keyEmptyCheck(
                    appointmentDetails?.type === 'MUNICIPALITY_BRANCH' ? 'location' : 'daro_office_location',
                  ),
                  value: (
                    <span className={classes.linkBtn}>
                      {appointmentDetails?.type === 'MUNICIPALITY_BRANCH' ? (
                        getDropdownLabelFromValue(
                          getSelectOptions('choose_municipality'),
                          appointmentDetails?.locationId,
                        )
                      ) : (
                        <Link
                          component='a'
                          href={`https://www.google.com/maps?q=${appointmentDetails?.latitude},${appointmentDetails?.longitude}`}
                          variant='body2'
                          className={classes.linkBtn}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {locale === 'en' ? appointmentDetails?.name : appointmentDetails?.nameAr}
                        </Link>
                      )}
                    </span>
                  ),
                },
              ]
            : []),
          ...(appointmentDetails?.type === 'DARI_AT_YOUR_PLACE'
            ? [
                {
                  label: keyEmptyCheck('Appointment_type'),
                  value: keyEmptyCheck('dari_at_your_Place'),
                },
                {
                  label: keyEmptyCheck('emirates'),
                  value: getDropdownLabelFromValue(
                    getSelectOptions('emirateLookup'),
                    appointmentDetails?.dariAtYourPlaceDetails?.municipalityId,
                  ),
                },
                {
                  label: keyEmptyCheck('Appoinment Location'),
                  value: appointmentDetails?.dariAtYourPlaceDetails?.locationName ?? '-',
                },
              ]
            : []),
          ...(appointmentDetails?.type === 'VIRTUAL_CALL'
            ? [
                {
                  label: keyEmptyCheck('Appointment_type'),
                  value: keyEmptyCheck('Virtual_video_call'),
                },
              ]
            : []),
          ...(appointmentDetails?.appointmentRequests &&
          appointmentDetails?.type !== 'DARI_AT_YOUR_PLACE' &&
          appointmentDetails?.type !== 'VIRTUAL_CALL'
            ? appointmentDetails.appointmentRequests
                .filter(request => request.status === 'SELECTED' || request.status === 'APPROVED')
                .map(request => ({
                  label: keyEmptyCheck('Selected_appointment'),
                  value: moment(request.visitDate).isValid()
                    ? moment(request.visitDate).format('DD/MM/YYYY') + ' ' + request.startTime + '-' + request.endTime
                    : '',
                }))
            : []),
          ...(appointmentDetails?.appointmentRequests &&
          (appointmentDetails?.appointmentRequests[0]?.status === 'SELECTED' ||
            appointmentDetails?.appointmentRequests[0]?.status === 'APPROVED') &&
          appointmentDetails?.type === 'VIRTUAL_CALL'
            ? [
                {
                  label: keyEmptyCheck('scheduled_meeting_link'),
                  value: appointmentDetails?.appointmentRequests[0]?.url
                    ? appointmentDetails?.appointmentRequests[0]?.url
                    : '-',
                },
                {
                  label: keyEmptyCheck('slot'),
                  value: moment(appointmentDetails?.appointmentRequests[0]?.visitDate).isValid()
                    ? moment(appointmentDetails?.appointmentRequests[0]?.visitDate).format('DD/MM/YYYY') +
                      ' ' +
                      appointmentDetails?.appointmentRequests[0]?.startTime +
                      '-' +
                      appointmentDetails?.appointmentRequests[0]?.endTime
                    : '',
                },
              ]
            : []),
        ],
      },
    ];
  }, [appointmentDetails]);
  return (
    <>
      <Paper variant='outlined' className={(classes.paperCardFrame, classes.marginBottom)}>
        <div className={classes.titleHead}>
          <Typography variant='h6' component='h1' className={classes.title}>
            {keyEmptyCheck(title)}
          </Typography>
        </div>
        {isEditable ? (
          <>
            <div className={classes.container}>
              <Typography variant='h6' component='h1' className={classes.strongText}>
                {selectOption ? keyEmptyCheck('Appointment_at') : keyEmptyCheck('select_appoinment_option')}

                <span className={classes.textDanger}>*</span>
              </Typography>
              <FormControl component='fieldset' className={classes.fieldsetradio}>
                <RadioGroup row aria-labelledby='demo-row-radio-buttons-group-label' name='row-radio-buttons-group'>
                  <FormControlLabel
                    value='MUNICIPALITY_BRANCH'
                    onClick={handleChange}
                    checked={appointmentDetails?.type === 'MUNICIPALITY_BRANCH'}
                    name='appoinmentDetails'
                    control={<Radio />}
                    label={keyEmptyCheck('Municipality_branch')}
                  />
                  <FormControlLabel
                    value='DARI_OFFICE'
                    checked={appointmentDetails?.type === 'DARI_OFFICE'}
                    onChange={handleChange}
                    name='appoinmentDetails'
                    control={<Radio />}
                    label={keyEmptyCheck('dari_offices')}
                  />
                  <FormControlLabel
                    value='DARI_AT_YOUR_PLACE'
                    checked={appointmentDetails?.type === 'DARI_AT_YOUR_PLACE'}
                    onChange={handleChange}
                    name='appoinmentDetails'
                    control={<Radio />}
                    label={keyEmptyCheck('dari_at_your_Place')}
                  />
                  <FormControlLabel
                    value='VIRTUAL_CALL'
                    checked={appointmentDetails?.type === 'VIRTUAL_CALL'}
                    onChange={handleChange}
                    name='appoinmentDetails'
                    control={<Radio />}
                    label={keyEmptyCheck('Virtual_video_call')}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {selectOption === 'MUNICIPALITY_BRANCH' && (
              <div className={classes.containerPad}>
                <hr className={classes.hrColor} />
                <div className={classes.flexArea}>
                  <ADGMSelect
                    name='locationId'
                    type='select'
                    label={keyEmptyCheck('Select_municipality_branch')}
                    // placeholder={<FormattedMessage {...messages.select_an_option} />}
                    required
                    options={getSelectOptions('choose_municipality')}
                    value={appointmentDetails?.locationId || null}
                    onChange={handleSelect}
                    customClasses={{ container: classes.adgmSelect }}
                  />

                  {selectDetail && (
                    <div className={classes.viewOnMap}>
                      <Link
                        component='a'
                        href={`https://www.google.com/maps?q=${selectDetail?.latitude},${selectDetail?.longitude}`}
                        variant='body2'
                        className={classes.linkBtn}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <ADGMImage name='map-marker.svg' /> {keyEmptyCheck('view_on_map')}
                      </Link>
                    </div>
                  )}
                </div>

                {selectDetail && (
                  <div className={classes.viewDetail}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={2}>
                        <ADGMItemDetails label={keyEmptyCheck('contact_details')} value={selectDetail?.mobile} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <ADGMItemDetails
                          label={keyEmptyCheck('working_hours')}
                          value={selectDetail?.workingHours || appointmentWorkingHours}
                        />
                      </Grid>
                    </Grid>
                  </div>
                )}
              </div>
            )}
            {selectOption === 'DARI_OFFICE' && (
              <div className={classes.containerPad}>
                <hr className={classes.hrColor} />
                <div className={classes.flexArea}>
                  <ADGMSelect
                    name='locationId'
                    type='select'
                    label={keyEmptyCheck('select_dari_office')}
                    // placeholder={<FormattedMessage {...messages.select_an_option} />}
                    required
                    options={getSelectOptions('dariOffice')}
                    value={appointmentDetails?.locationId || null}
                    onChange={handleSelect}
                    customClasses={{ container: classes.adgmSelect }}
                  />

                  {selectDetail && (
                    <div className={classes.viewOnMap}>
                      <Link
                        component='a'
                        href={`https://www.google.com/maps?q=${selectDetail?.latitude},${selectDetail?.longitude}`}
                        variant='body2'
                        className={classes.linkBtn}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <ADGMImage name='map-marker.svg' /> {keyEmptyCheck('view_on_map')}
                      </Link>
                    </div>
                  )}
                </div>
                <ADGMAlert visible type='info' className={classes.viewDetailInfoMain}>
                  <div className={classes.viewDetailInfo}>
                    {keyEmptyCheck('extra_charge_1050')}

                    <Link component='a' href={`/${locale}/app/adgm-offices`} variant='body2'>
                      {keyEmptyCheck('Click_here_to_know_more_about_the_ADGM_Office')}
                    </Link>
                  </div>
                </ADGMAlert>
                {selectDetail && (
                  <div className={classes.viewDetail}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={2}>
                        <ADGMItemDetails label={keyEmptyCheck('contact_details')} value={selectDetail?.mobile} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <ADGMItemDetails
                          label={keyEmptyCheck('working_hours')}
                          value={selectDetail?.workingHours || appointmentWorkingHours}
                        />
                      </Grid>
                    </Grid>
                  </div>
                )}
              </div>
            )}
            {selectOption === 'DARI_AT_YOUR_PLACE' && (
              <div className={classes.containerPad}>
                <hr className={classes.hrColor} />
                <div className={classes.flexAreaADGM}>
                  <div>
                    <Typography variant='h6' component='h1' className={classes.strongText}>
                      {keyEmptyCheck('dari_at_your_Place')}
                    </Typography>
                    <Typography variant='h6' component='h1' className={classes.strongText}>
                      {keyEmptyCheck('Choose_your_preferred_location_to_schedule_the_appointment.')}
                    </Typography>
                  </div>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <ADGMSelect
                        name='emirate'
                        type='select'
                        value={appointmentDetails?.dariAtYourPlaceDetails?.municipalityId || null}
                        label={<FormattedMessage {...messages.Select_emirate} />}
                        placeholder={<FormattedMessage {...messages.Select_emirate} />}
                        required
                        options={getSelectOptions('emirateLookup')}
                        onChange={handleSelect}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ADGMTextField
                        customClasses={{ field: classes.inputTxt, input: classes.nonUAEInput }}
                        id='search-box-input'
                        placeholder={intl.formatMessage({ ...messages.sel_appoinemt_location_map })}
                        required
                        onClick={handleCloseModal}
                        label={keyEmptyCheck('select_appoiment_location')}
                        name='selectedPin'
                        InputProps={{
                          endAdornment: (
                            <>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='18'
                                height='20'
                                viewBox='0 0 18 20'
                                fill='none'
                              >
                                <path
                                  d='M8.70853 19.1292L8.70855 19.1292L8.70412 19.1255C8.31372 18.7986 6.38825 17.1409 4.56502 15.0241C3.65331 13.9657 2.77733 12.8041 2.1316 11.6463C1.48188 10.4813 1.08984 9.36358 1.08984 8.38199C1.08984 4.03321 4.61524 0.507812 8.96402 0.507812C13.3128 0.507812 16.8382 4.03321 16.8382 8.38199C16.8382 9.3636 16.4462 10.4814 15.7965 11.6464C15.1508 12.8042 14.2749 13.966 13.3634 15.0247C11.5406 17.1417 9.61598 18.8003 9.22554 19.1302L9.22517 19.1305L8.96603 19.3499L8.70853 19.1292ZM8.96459 1.31855L8.96346 1.31856C5.06459 1.32297 1.90504 4.48252 1.90062 8.38139V8.38195C1.90062 9.19345 2.21111 10.0756 2.66522 10.9427C3.12363 11.8179 3.75251 12.7228 4.44289 13.5914C5.8239 15.329 7.48624 16.965 8.63011 17.9913L8.96409 18.291L9.29801 17.9913C10.4419 16.9645 12.1042 15.3276 13.4852 13.5898C14.1756 12.7211 14.8044 11.8162 15.2628 10.9412C15.7169 10.0744 16.0274 9.1927 16.0274 8.38195V8.38139C16.023 4.48252 12.8635 1.32301 8.96459 1.31855Z'
                                  fill='#096BCE'
                                  stroke='#096BCE'
                                />
                                <path
                                  d='M8.96398 11.2014C7.40685 11.2014 6.14453 9.93909 6.14453 8.38195C6.14453 6.82481 7.40685 5.5625 8.96398 5.5625C10.5211 5.5625 11.7834 6.82481 11.7834 8.38195C11.7834 9.9391 10.5212 11.2014 8.96398 11.2014ZM8.96398 6.22219C7.7712 6.22219 6.80426 7.18913 6.80426 8.38191C6.80426 9.5747 7.7712 10.5416 8.96398 10.5416C10.1568 10.5416 11.1237 9.5747 11.1237 8.38191C11.1237 7.18914 10.1568 6.22219 8.96398 6.22219Z'
                                  fill='#096BCE'
                                  stroke='#096BCE'
                                />
                              </svg>
                            </>
                          ),
                        }}
                        disabled
                        value={selectedPin?.name || ''}
                      />
                    </Grid>
                  </Grid>
                </div>
                <ADGMAlert visible type='info' className={classes.viewDetailInfoMain}>
                  <div className={classes.viewDetailInfo}>
                    {keyEmptyCheck('Extra_charge_for_ADGM_at_your_place_service_is_AED_3000_for_this_application')}
                    <Link component='a' href={`/${locale}/app/adgm-offices`} variant='body2'>
                      {keyEmptyCheck('Click_here_to_know_more_about_the_ADGM_at_your_place')}
                    </Link>
                  </div>
                </ADGMAlert>
              </div>
            )}
            {selectOption === 'VIRTUAL_CALL' && (
              <div className={classes.containerPad}>
                <ADGMAlert visible type='info' className={classes.viewDetailInfoMain}>
                  {keyEmptyCheck(
                    'We_will_send_you_the_available_time_slots_once_the_application_is_approved_by_the_municipality',
                  )}
                </ADGMAlert>
              </div>
            )}
            <ADGMSelectMap
              handleCloseModal={handleCloseModal}
              isModalOpen={isModalOpen}
              onSubmitLocation={onSubmitLocation}
              previousSelectedPin={selectedPin}
            />
          </>
        ) : (
          <>
            <div className={classes.panelPadding}>
              <ADGMPanelInputsGeneratorBody
                bodyStyle={classes.containerPadding}
                isEditable={isEditable}
                sections={SELLING_DETAILS_PANEL_FIELDS}
              />
              {(appointmentDetails?.type === 'MUNICIPALITY_BRANCH' || appointmentDetails?.type === 'DARI_OFFICE') && (
                <>
                  <div
                    style={{
                      height: '300px',
                      margin: '15px',
                      overflow: 'hidden',
                    }}
                  >
                    {selectDetail && <ADGMMap lng={selectDetail?.longitude} lat={selectDetail?.latitude} />}
                  </div>
                  {appointmentDetails?.type === 'DARI_OFFICE' && (
                    <div className={classes.containerPad}>
                      <ADGMAlert visible type='info' className={classes.viewDetailInfoMain}>
                        <div className={classes.viewDetailInfo}>
                          {keyEmptyCheck('extra_charge_1050')}
                          <Link component='a' href={`/${locale}/app/adgm-offices`} variant='body2'>
                            {keyEmptyCheck('Click_here_to_know_more_about_the_ADGM_Office')}
                          </Link>
                        </div>
                      </ADGMAlert>
                    </div>
                  )}
                </>
              )}

              {appointmentDetails?.type === 'VIRTUAL_CALL' &&
                !auditorFlow &&
                appointmentDetails?.appointmentRequests[0]?.status !== 'SELECTED' && (
                  <div className={classes.containerPad}>
                    <ADGMAlert visible type='info' className={classes.viewDetailInfoMain}>
                      {keyEmptyCheck(
                        'We_will_send_you_the_available_time_slots_once_the_application_is_approved_by_the_municipality',
                      )}
                    </ADGMAlert>
                  </div>
                )}
              {appointmentDetails?.type === 'DARI_AT_YOUR_PLACE' && (
                <div className={classes.containerPad}>
                  <ADGMAlert visible type='info' className={classes.viewDetailInfoMain}>
                    <div className={classes.viewDetailInfo}>
                      {keyEmptyCheck('Extra_charge_for_ADGM_at_your_place_service_is_AED_3000_for_this_application')}
                      <Link component='a' href={`/${locale}/app/adgm-offices`} variant='body2'>
                        {keyEmptyCheck('Click_here_to_know_more_about_the_ADGM_at_your_place')}
                      </Link>
                    </div>
                  </ADGMAlert>
                </div>
              )}
            </div>
          </>
        )}
      </Paper>
    </>
  );
};

export default withStyles(styles)(injectIntl(AppoimentDetails));
